import LoadingPage from './200'
export default LoadingPage